module.exports = __webpack_public_path__ + "static/media/vumask.dd2f0a93.png";